export enum LazoPaths {
  INDEX = "/",
  UNAUTHORIZED = "/unauthorized",
  REGISTER = "/register",
  USER_MANAGEMENT = "/portal/admin/user-management",
  DASHBOARD = "/one/accounting/home",
  DASHBOARD_SELECTION = "/one/accounting/dashboards",
  DASHBOARD_DETAILS = "/one/accounting/dashboard/:externalId",
  TAX_DEADLINES = "/one/accounting/tax-deadlines",
  TAX_TIMELINE = "/one/accounting/tax-timeline",
  ONBOARDING = "/onboarding/:codeExternalId",
  INTEGRATIONS = "/one/integrations",
  LOGIN = "/login",
  TERMS_AND_POLICIES = "/terms-and-policies",
  FREQUENTLY_ASKED_QUESTIONS = "/faq",
  COMPANY_FORM = "/company-form",
  USER_PROFILE = "/one/profile",
  LEGAL = "/one/legal",
  ADVERTISING = "/one/advertising",
  TASKS = "/one/tasks",
  NOTIFICATIONS = "/one/notifications",
  NEW_TASK = "/portal/tasks/new/:isBulkCreation",
  TASKS_ADMIN = "/portal/tasks/admin",
  TASK_DETAILS = "/portal/task-details/:taskExternalId",
  FUNDRAISING = "/one/fundraising",
  FUNDRAISING_ADVANCED_SEARCH = "/one/fundraising/advanced-search/:externalId/:searchExternalId",
  FUNDER_LIST_DETAIL = "/one/fundraising/smart-list/:externalId",
  PORTAL_CUSTOMERS = "/portal/customers",
  PORTAL_NOTIFICATIONS = "/portal/notifications",
  PORTAL_CUSTOMERS_DETAILS = "/portal/customers/details",
  PORTAL_INBOX = "/portal/inbox/:LazoChatTeamExternalId",
  PORTAL_TAX_TIMELINE = "/portal/tax-timeline",
  INVITATION_COMPANY = "/invitation/company/:userEmail/:invitationExternalId",
  ONE_SETTINGS = "/one/settings",
  CHECKOUT = "/checkout/:companyName/:annualExpenses",
  ONE_COMPANY_ADD = "/one/company-add",
  ONE_TASK_DETAILS = "/one/task-details/:taskExternalId",
  VERIFY_EMAIL = "/verify-email/:userExternalId",
  VERIFYING_EMAIL = "/verifying-email/:code",
  REGISTER_USER_FOR_COMPANY = "/company/invitation/register-user/:userEmail/:invitationExternalId",
  PERSONAL_INFORMATION = "/personal-information",
  FORGOT_PASSWORD = "/forgot-password",
  FORGOT_PASSWORD_EMAIL_SENT = "/forgot-password/email-sent",
  RESET_PASSWORD = "/reset-password",
  NOT_SUPPORTED = "/not-supported",
  PRODUCT_MANAGER = "/portal/product-manager",
  PRODUCT_MANAGER_TEMPLATES = "/portal/product-manager?tab=templates",
  PRODUCT_MANAGER_WORKFLOWS = "/portal/product-manager?tab=workflows",
  PRODUCT_MANAGER_SERVICES = "/portal/product-manager?tab=services",
  PRODUCT_FLOW_TASKS = "/portal/product-manager/:productFlowExternalId",
  PRODUCT_FLOW_TASKS_V2 = "/portal/product-manager/workflow-detail-v2/:productFlowExternalId",
  PRODUCT = "/one/services",
  ONE_COMMUNICATIONS = "/one/communications/:LazoChatTeamExternalId",
  PORTAL_SETTINGS = "/portal/settings",
  ONE_DOCUMENT_CENTER = "/one/document-center",
  PORTAL_DOCUMENT_CENTER = "/portal/document-center",
  LAZO_TEAM = "/portal/lazo-team",
  LAZO_TEAM_MEMBER_DETAILS = "/portal/lazo-team/member/:externalId",
  PORTAL_CUSTOMERS_ACCOUNTING = "/portal/customers/details/accounting",
  CSV_IMPORT_TOOL = "/tools/csv-import",
  LOG_ME_AS = "/tools/logmeas",
  ONE_DATA_ROOM = "/one/data-room",
  ONE_VIRTUAL_DATA_ROOMS = "/one/virtual-data-rooms",
  ONE_DATA_ROOM_FILES = "/one/data-room/files",
  ADMINT_TOOLS = "/tools/admin",
  SHARED_CHECK_EMAIL = "/shared-check-email",
  ROOM_EXPIRED = "/room-expired",
  SHARED_FOR_LOGIN = "/shared-for-login",
  // These should be deleted
  VIRTUAL_ROOM_ANALYTICS = "/one/virtual-data-room/analytics",
  ONE_VIRTUAL_DATA_ROOMS_CREATE = "/one/virtual-data-rooms/create",
  ONE_VIRTUAL_DATA_ROOMS_INSIDE = "/one/virtual-data-rooms/inside",
  SHARE_BY_LINK = "/share-by-link",
  SHARED_VIRTUAL_DATA_ROOM = "/virtual-data-rooms/shared",
  VIRTUAL_DATA_ROOM_FINANCIAL_REPORT = "/one/virtual-data-rooms/financial-report",
  SHARE_VIRTUAL_DATA_ROOM_FINANCIAL_REPORT = "/spaces/shared/financial-report",
  HOME = "/one/home",
  SPENDING = "/one/spending",
  ONE_SPENDING_DETAILS = "/one/spending/details",
  ONE_VIRTUAL_DATA_ROOMS_FILE = "/one/virtual-data-rooms/file",
  SIGNUP = "/signup",
  SIGNUP_COUNTRY_SELECT = "/signup/country-select",
  SIGNUP_COMPANY = "/signup/company",
  SIGNUP_INDIVIDUAL = "/signup/individual",
  SIGNUP_COMPANY_INCORPORATION = "/signup/company/incorporation",
  SIGNUP_COMPANY_INFO = "/signup/company/info",
  SIGNUP_ACCOUNT_TYPE = "/signup/account-type",
  SIGNUP_COMPANY_CONNECT = "/signup/company/connect",
  SHARED_VIRTUAL_DATA_ROOMS_FILE = "/spaces/shared/file",
  REDIRECT = "/redirect",
  ONE_PAYWALL_ADD_BILLING_DETAILS = "/one/paywall/add-billing-details",
  ONE_PAYWALL = "/one/paywall",
  ONE_PAYWALL_CHOOSE_PLAN = "/one/paywall/choose-plan",
  ONE_PAYWALL_SELECT_ADD_ONS = "/one/paywall/select-add-ons",
  ONE_PAYWALL_CONFIRM_PURCHASE = "/one/paywall/confirm-purchase",
  ONE_SIGNUP = "/one/signup",

  DOCUMENT_MANAGER = "/portal/document-manager",
  SEARCH_AND_REPORTING = "/portal/search-and-reporting",
  ORG_CHART = "/portal/org-chart",
  WORKFLOW_TEMPLATES = "/portal/product-manager?tab=templates",
  MY_SERVICES = "/one/my-services",
  MY_COMPANIES = "/one/my-companies",
  ONE_MY_SERVICES_WORKFLOW_DETAIL = "/one/my-services/workflow/:productFlowExternalId",
  TOOLS = "/portal/tools",
  TOOLS_BATCH_EMAIL = "/portal/tools/batch-email",
  TOOLS_BULK_DOC_UPLOAD = "/portal/tools/bulk-doc-upload",
  TOOLS_BULK_FUP = "/portal/tools/bulk-fup",
  TOOLS_CHANGE_PASSWORD = "/portal/tools/change-password",
}

// Workflow Templates URL builders
export const WorkflowTemplatesPaths = {
  list: () => LazoPaths.PRODUCT_MANAGER_TEMPLATES,
  view: (externalId: string) => `${LazoPaths.PRODUCT_MANAGER_TEMPLATES}&view=${externalId}`,
  edit: (externalId: string) => `${LazoPaths.PRODUCT_MANAGER_TEMPLATES}&edit=${externalId}`,
  create: () => `${LazoPaths.PRODUCT_MANAGER_TEMPLATES}&create=true`,
} as const;

export const LazoPathsWithChat: LazoPaths[] = [
  LazoPaths.FUNDRAISING,
  LazoPaths.FUNDRAISING_ADVANCED_SEARCH.replace(":externalId", "").replace(":searchExternalId", "") as LazoPaths,
  LazoPaths.DASHBOARD,
  LazoPaths.FUNDER_LIST_DETAIL.replace(":externalId", "") as LazoPaths,
  LazoPaths.PORTAL_CUSTOMERS_ACCOUNTING as LazoPaths,
  LazoPaths.ONE_DATA_ROOM,
  LazoPaths.ONE_VIRTUAL_DATA_ROOMS_INSIDE,
  LazoPaths.SHARED_VIRTUAL_DATA_ROOM,
];
